import { Employee } from '../types/employee';

export const isEmployee = (obj: any): obj is Employee => {
	return (
		typeof obj.Id === 'string' &&
		typeof obj.FirstName === 'string' &&
		typeof obj.LastName === 'string' &&
		typeof obj.FullName === 'string'
	);
};
